/**
 * Copilot 主面板布局常量与宽度计算（浮窗 / 内嵌槽位唯一数据源）。
 */

/** 悬浮窗默认距视口顶部的偏移（与 DragResizeBox defaultY、safeArea.top 一致） */
export const COPILOT_PANEL_DEFAULT_TOP = 60;

/** 悬浮面板可拖拽缩小的最小宽度 */
export const COPILOT_PANEL_MIN_WIDTH = 483;

/** 大屏下的设计默认宽（现网浮窗默认约 520px） */
const COPILOT_PANEL_DESIGN_WIDTH = 520;

/** 浮窗最大宽度占视口比例（与 CopilotPanelShell 约束一致） */
export const COPILOT_PANEL_MAX_WIDTH_RATIO = 0.75;

/**
 * 计算浮窗可拉伸的最大宽度。
 * @returns 当前视口宽度 × {@link COPILOT_PANEL_MAX_WIDTH_RATIO}
 */
export function getCopilotPanelMaxWidth(): number {
  return window.innerWidth * COPILOT_PANEL_MAX_WIDTH_RATIO;
}

/**
 * 计算面板初始宽度：在 [minWidth, 75% 视口宽] 内取设计宽 520，小屏回落到 min。
 * 内嵌槽位 CSS 变量、boxWidth、DragResizeBox defaultWidth 均使用此函数。
 * @returns 像素宽度
 */
export function getCopilotPanelInitialWidth(): number {
  const maxWidth = getCopilotPanelMaxWidth();
  return Math.min(
    maxWidth,
    Math.max(COPILOT_PANEL_MIN_WIDTH, COPILOT_PANEL_DESIGN_WIDTH),
  );
}
